import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  eventListItemContainer: {
    "& .MuiCard-root": {
      display: "flex",
      marginBottom: "20px",
      flexDirection: "column",
      border: `1px solid ${theme.palette.events.grayShade1}`,
      boxShadow: "4px 4px 4px 0px #0C38911A !important",
      borderRadius: "5px",
      position: "relative",
      maxWidth: "calc(100% - 10px)",
      color: `${theme.palette.text.primary} !important`,

      "& .MuiCardHeader-root": {
        display: "flex",
        padding: "13px 0 0px 12px",
        alignItems: "center",
        position: "absolute",
        alignSelf: "flex-end",
        width: "100%",
        boxSizing: "border-box",
      },

      "& .MuiCardHeader-action": {
        flex: "1 0 100%",
        position: "relative",
        left: "-14px",
      },
      "& .MuiCardMedia-root": {
        "& img": {
          width: "100%",
          height: "200px",
          objectFit: "cover",
          transition: "all 0.2s ease-in-out",
        },
      },
    },
    "&:hover": {
      $menuItem: {
        right: "0px",
        visibility: "visible",
        opacity: 1,
        zIndex: 1,
      },

      "& .MuiCardMedia-root": {
        "& img": {
          opacity: 0.8,
        },
      },
    },
  },
  menu: {
    display: "flex",
    color: `${theme.palette.text.primary} !important`,
  },
  menuItem: {
    padding: "5px",
    boxSizing: "border-box",
    display: "flex",
    margin: "auto 3px",
    transition: "all 0.2s ease-in-out",
    right: 0,
    width: "36px",
    height: "36px",
    color: theme.palette.events.blueSecondary,
    background: theme.palette.white,
    border: `1px solid ${theme.palette.events.blueSecondary}`,
    borderRadius: "50%",

    "&:hover": {
      background: theme.palette.white,
    },

    "& svg": {
      width: "100%",
      height: "100%",
      maxWidth: "24px",
    },
  },
  menuList: {
    padding: "5px 0px !important",
  },
  privateEvent: {
    display: "flex",
    alignItems: "center",
    color: "#fff",
    boxSizing: "border-box",
    margin: "auto 3px",
    height: "36px",
    transition: "all 0.2s ease-in-out",
    padding: "6px 20px 6px 20px",
    borderRadius: "100px",
    background: theme.palette.events.blue,
  },
  listItem: {
    padding: "8px 15px",
    color: `${theme.palette.text.primary} !important`,
    display: "flex",
    alignItems: "center",
    gap: "8px",

    "& svg": {
      fontSize: "20px",
      color: theme.palette.events.blueSecondary,
    },
  },
  unlimitedPrivateEvent: {
    width: "35%",
    marginTop: "5px",
  },
  reopenDialogContent: {
    textAlign: "left",
  },
  activeSpaceName: {
    marginTop: "25px",
    fontWeight: 500,
  },
  privateEventText: {
    fontSize: "16px",
    fontWeight: 700,
  },
}));
